import React from 'react';
import { ShimmerThumbnailImage } from '../../default/popup/shimmerImage/shimmerImage';
import ActionLink from '../../default/common/formatActionUrl';
const SingleWidgetList = ({ data }) => {

    return (
        <div className="card-container single-business-widgets">
            <div className="settings-list-wrapper">
                <div className="single-settings">
                    <h3 className="setting-title">Widgets</h3>
                    <div className="setting-content">
                        {data?.widgets && data.widgets.data && data.widgets.data.length > 0 ? (
                            <div className="sng-content-repeater bs-wgt-wrapper">
                                {data.widgets.data.map((item) => (
                                    <div className="sng-content-widget" key={item.id}>
                                        <div className="sng-wgt-left">
                                            {item.selected_icon_id === "svg" && (
                                               <ShimmerThumbnailImage 
                                               height={10} 
                                               src={item.widget_info.svg_icon}
                                               />
                                            )}
                                            <span>{item.title}</span>
                                        </div>
                                        <ActionLink type={item.widget_info.type_id} url={item.action_url} />
                                    </div>
                                ))}
                            </div>
                        ) : (
                            'no widget found add new here'
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SingleWidgetList;
